export const ADD_EMAIL_INTEGRATION="ADD_EMAIL_INTEGRATION"
export const ADD_EMAIL_INTEGRATION_SUCCESS="ADD_EMAIL_INTEGRATION_SUCCESS"
export const ADD_EMAIL_INTEGRATION_FAILED="ADD_EMAIL_INTEGRATION_FAILED"
export const GET_EMAIL_INTEGRATION="GET_EMAIL_INTEGRATION"
export const GET_EMAIL_INTEGRATION_SUCCESS="GET_EMAIL_INTEGRATION_SUCCESS"
export const GET_EMAIL_INTEGRATION_FAILED="GET_EMAIL_INTEGRATION_FAILED"
export const GET_EMAIL_TEST="GET_EMAIL_TEST"
export const GET_EMAIL_TEST_SUCCESS="GET_EMAIL_TEST_SUCCESS"
export const GET_EMAIL_TEST_FAILED="GET_EMAIL_TEST_FAILED"

